
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/backdrop",
      function () {
        return require("private-next-pages/material-ui/api/backdrop.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/backdrop"])
      });
    }
  